import "./AboutUs.css";
function Hero() {
  return (
    <div className="about-hero-main-container">
      <div class="about-hero-content">
        <div className="about-hero-text-box">
          <div className="about-hero-sub-text">Made by India, For India</div>
          <h1 className="about-hero-head-text">
            A super app that puts personal recommendations first!
          </h1>
        </div>
      </div>
    </div>
  );
}

export default Hero;
